// extracted by mini-css-extract-plugin
export default {"-large":"gLzMgpJJE2oLIIjB5jAt","customDropDownSpacing":"gBeRyXpTUgPuQ2S17v8g","customModalSpacing":"SrcLqZcwR8QdzU47NRXg"};